// extracted by mini-css-extract-plugin
export default {"provablyFairWrap":"styles_provablyFairWrap__J2T+M","provablyFairTitle":"styles_provablyFairTitle__TZR4x","provablyFairBody":"styles_provablyFairBody__8BsmD"};